var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step-subcription-root" },
    [
      _vm.contactDialog
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingContactDialog,
                  expression: "loadingContactDialog"
                }
              ],
              attrs: {
                visible: true,
                fullscreen: true,
                width: "100%",
                "before-close": _vm.closeBillingContactForm
              }
            },
            [
              _c("header", { staticClass: "mb-5 p-6" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "round-64 relative dinlineb valign-middle primary-50-bkg"
                  },
                  [
                    _c("i", {
                      staticClass: "fab fa-sellsy absolute-center white",
                      staticStyle: { "font-size": "26px" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dinlineb valign-middle ml-3" }, [
                  _c("h2", { staticClass: "m-0 mb-2 dinlineb" }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Abonnement Sellsy")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "link block semibold",
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          _vm.contactDialog = false
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "icon-arrow-back mr-1" }),
                      _vm._v(_vm._s(_vm.$l10n.__("Retour")))
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "container-tiny m-auto" }, [
                _vm.$slots["header"] != ""
                  ? _c("h2", { staticClass: "mt-0" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$filters.capitalize(
                              _vm.$l10n.__("informations de contact")
                            )
                          ) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "gray-60" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$filters.capitalize(
                          _vm.$l10n.__(
                            "définissez l'ensemble des informations manquantes à la facturation."
                          )
                        )
                      ) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("h4", [
                      _vm._v(
                        _vm._s(_vm.$filters.capitalize(_vm.$l10n.__("contact")))
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      {
                        ref: "billingContactForm",
                        attrs: {
                          model: _vm.billingContactTmp,
                          "label-position": "top",
                          "inline-message": true,
                          rules: _vm.samBillingContactRules
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__("common.labels.first_name"),
                              prop: "contactFirstName",
                              error: _vm.errors.get("contactFirstName")
                            }
                          },
                          [
                            _c("text-input", {
                              attrs: { mode: "edit" },
                              model: {
                                value: _vm.billingContactTmp.contactFirstName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.billingContactTmp,
                                    "contactFirstName",
                                    $$v
                                  )
                                },
                                expression: "billingContactTmp.contactFirstName"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__("common.labels.name"),
                              prop: "contactName",
                              error: _vm.errors.get("contactName")
                            }
                          },
                          [
                            _c("text-input", {
                              attrs: { mode: "edit" },
                              model: {
                                value: _vm.billingContactTmp.contactName,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.billingContactTmp,
                                    "contactName",
                                    $$v
                                  )
                                },
                                expression: "billingContactTmp.contactName"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__("common.labels.email_address"),
                              prop: "contactEmail",
                              error: _vm.errors.get("contactEmail")
                            }
                          },
                          [
                            _c("text-input", {
                              attrs: { type: "email", mode: "edit" },
                              model: {
                                value: _vm.billingContactTmp.contactEmail,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.billingContactTmp,
                                    "contactEmail",
                                    $$v
                                  )
                                },
                                expression: "billingContactTmp.contactEmail"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__("common.labels.phone"),
                              prop: "contactPhone",
                              error: _vm.errors.get("contactPhone")
                            }
                          },
                          [
                            _c("tel-input", {
                              attrs: { mode: "edit" },
                              on: { change: _vm.updateBilligContactPhoneTmp },
                              model: {
                                value: _vm.billingContactPhoneTmp,
                                callback: function($$v) {
                                  _vm.billingContactPhoneTmp = $$v
                                },
                                expression: "billingContactPhoneTmp"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__(
                                "common.labels.invoicing_language"
                              ),
                              prop: "locale",
                              error: _vm.errors.get("locale")
                            }
                          },
                          [
                            _c("select-input", {
                              staticClass: "m-0",
                              attrs: {
                                mode: "edit",
                                options: _vm.billingLocales,
                                "label-column": "name",
                                "id-column": "code",
                                filterable: true
                              },
                              model: {
                                value: _vm.billingContactTmp.locale,
                                callback: function($$v) {
                                  _vm.$set(_vm.billingContactTmp, "locale", $$v)
                                },
                                expression: "billingContactTmp.locale"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              rules: _vm.additionalEmailRecipientsRules,
                              label: _vm.$t.__(
                                "common.labels.offer_recipient_emails"
                              ),
                              prop: "additionalEmailRecipients",
                              error: _vm.errors.get("additionalEmailRecipients")
                            }
                          },
                          [
                            _c("el-select", {
                              staticClass: "wp-10 no-caret",
                              attrs: {
                                multiple: "",
                                filterable: "",
                                "default-first-option": "",
                                "allow-create": "",
                                "collapse-tags": false,
                                "popper-class": "hidden",
                                placeholder: _vm.$t.__(
                                  "common.actions.search_email"
                                )
                              },
                              model: {
                                value:
                                  _vm.billingContactTmp
                                    .additionalEmailRecipients,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.billingContactTmp,
                                    "additionalEmailRecipients",
                                    $$v
                                  )
                                },
                                expression:
                                  "billingContactTmp.additionalEmailRecipients"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt-6 aright" },
                          [
                            _c("CompassButton", {
                              attrs: {
                                label: _vm.$filters.capitalize(
                                  _vm.$t.__("common.actions.cancel")
                                ),
                                type: "secondary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.contactDialog = false
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("CompassButton", {
                              attrs: {
                                label: _vm.$filters.capitalize(
                                  _vm.$t.__(
                                    "sellsyaccountmanager.subscriptionform.StepSubscription.save_contact_informations"
                                  )
                                ),
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.submitForm(
                                    "billingContactForm",
                                    "saveBillingContact"
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.addressDialog
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingAddressDialog,
                  expression: "loadingAddressDialog"
                }
              ],
              attrs: {
                visible: true,
                fullscreen: true,
                width: "100%",
                "before-close": _vm.closeBillingAddressForm
              }
            },
            [
              _c("header", { staticClass: "mb-5 p-6" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "round-64 relative dinlineb valign-middle primary-50-bkg"
                  },
                  [
                    _c("i", {
                      staticClass: "fab fa-sellsy absolute-center white",
                      staticStyle: { "font-size": "26px" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dinlineb valign-middle ml-3" }, [
                  _c("h2", { staticClass: "m-0 mb-2 dinlineb" }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Abonnement Sellsy")))
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "link block semibold",
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function($event) {
                          _vm.addressDialog = false
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "icon-arrow-back mr-1" }),
                      _vm._v(_vm._s(_vm.$l10n.__("Retour")))
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "container-tiny m-auto" }, [
                _vm.$slots["header"] != ""
                  ? _c("h2", { staticClass: "mt-0" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$filters.capitalize(
                              _vm.$l10n.__("informations de facturation")
                            )
                          ) +
                          "\n            "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", { staticClass: "gray-60" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$filters.capitalize(
                          _vm.$l10n.__(
                            "définissez l'ensemble des informations manquantes à la facturation"
                          )
                        )
                      ) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("h4", [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.capitalize(
                            _vm.$l10n.__("adresse de facturation")
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      {
                        ref: "billingAddressForm",
                        attrs: {
                          model: _vm.billingAddressTmp,
                          "label-position": "top",
                          "inline-message": true,
                          rules: _vm.samBillingAddressAndIntraVatRules
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__("common.labels.street_name"),
                              prop: "line1",
                              error: _vm.errors.get("line1")
                            }
                          },
                          [
                            _c("algolia-places", {
                              attrs: {
                                "default-value": _vm.billingAddressTmp.line1,
                                templates: {
                                  value: function(suggestion) {
                                    return suggestion.name
                                  }
                                }
                              },
                              on: { "bubble-address": _vm.captureAddress }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__(
                                "common.labels.more_address_informations"
                              ),
                              prop: "line2",
                              error: _vm.errors.get("line2")
                            }
                          },
                          [
                            _c("text-input", {
                              attrs: { mode: "edit" },
                              model: {
                                value: _vm.billingAddressTmp.line2,
                                callback: function($$v) {
                                  _vm.$set(_vm.billingAddressTmp, "line2", $$v)
                                },
                                expression: "billingAddressTmp.line2"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__("common.labels.postal_code"),
                              prop: "postalCode",
                              error: _vm.errors.get("postalCode")
                            }
                          },
                          [
                            _c("text-input", {
                              attrs: { mode: "edit" },
                              model: {
                                value: _vm.billingAddressTmp.postalCode,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.billingAddressTmp,
                                    "postalCode",
                                    $$v
                                  )
                                },
                                expression: "billingAddressTmp.postalCode"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__("common.labels.city"),
                              prop: "city",
                              error: _vm.errors.get("city")
                            }
                          },
                          [
                            _c("text-input", {
                              attrs: { mode: "edit" },
                              model: {
                                value: _vm.billingAddressTmp.city,
                                callback: function($$v) {
                                  _vm.$set(_vm.billingAddressTmp, "city", $$v)
                                },
                                expression: "billingAddressTmp.city"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__("common.labels.state"),
                              prop: "state",
                              error: _vm.errors.get("state")
                            }
                          },
                          [
                            _c("text-input", {
                              attrs: { mode: "edit" },
                              model: {
                                value: _vm.billingAddressTmp.state,
                                callback: function($$v) {
                                  _vm.$set(_vm.billingAddressTmp, "state", $$v)
                                },
                                expression: "billingAddressTmp.state"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t.__("common.labels.country"),
                              prop: "country",
                              error: _vm.errors.get("country")
                            }
                          },
                          [
                            _c("select-input", {
                              attrs: {
                                mode: "edit",
                                options: _vm.countries,
                                "label-column": "name",
                                "id-column": "code",
                                filterable: true
                              },
                              model: {
                                value: _vm.billingAddressTmp.country,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.billingAddressTmp,
                                    "country",
                                    $$v
                                  )
                                },
                                expression: "billingAddressTmp.country"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.hasCountryIntraVat(_vm.billingAddressTmp.country)
                          ? _c(
                              "div",
                              [
                                _c("p", { staticClass: "mt-4" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Entrez votre numéro de TVA intracommunautaire ci-dessous pour être facturé en franchise de TVA."
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t.__(
                                        "common.labels.tax_number"
                                      ),
                                      prop: "vatIdentificationNumber",
                                      error: _vm.errors.get(
                                        "vatIdentificationNumber"
                                      )
                                    }
                                  },
                                  [
                                    _c("text-input", {
                                      attrs: { mode: "edit" },
                                      model: {
                                        value:
                                          _vm.billingAddressTmp
                                            .vatIdentificationNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.billingAddressTmp,
                                            "vatIdentificationNumber",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "billingAddressTmp.vatIdentificationNumber"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt-6 aright" },
                          [
                            _c("CompassButton", {
                              attrs: {
                                label: _vm.$filters.capitalize(
                                  _vm.$t.__("common.actions.cancel")
                                ),
                                type: "secondary"
                              },
                              on: {
                                click: function($event) {
                                  _vm.addressDialog = false
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("CompassButton", {
                              attrs: {
                                label: _vm.$filters.capitalize(
                                  _vm.$t.__("common.actions.save")
                                ),
                                type: "primary"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.submitForm(
                                    "billingAddressForm",
                                    "saveBillingAddressAndVatIdentificationNumber"
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "flex-level" }, [
        _c("h1", { staticClass: "flex-1 m-0" }, [
          _vm._v(
            _vm._s(_vm.$filters.capitalize(_vm.$l10n.__("votre abonnement")))
          )
        ]),
        _vm._v(" "),
        _vm.isCartLoaded
          ? _c("span", { staticClass: "flex-right semibold" }, [
              _vm._v(
                _vm._s(
                  _vm.$filters.capitalize(
                    _vm.$l10n.__("cette offre expire le %(expiration_date)s", {
                      expiration_date: _vm.$filters.dateFormatter(
                        _vm.cartExpiredDateObj.unix(),
                        "NORMAL_DATE",
                        false
                      )
                    })
                  )
                )
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "subscriptionForm",
          attrs: {
            "label-position": "top",
            inline: false,
            "inline-message": true,
            model: _vm.subscription
          }
        },
        [
          _c("h2", { staticClass: "mt-3" }, [
            _vm._v(
              _vm._s(_vm.$filters.capitalize(_vm.$l10n.__("vos informations")))
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex-level flex-row" }, [
            _c(
              "div",
              {
                staticClass: "well flex-column flex-item-50 mr-3 pb-5 relative"
              },
              [
                _c("h4", { staticClass: "mt-0" }, [
                  _vm._v(
                    _vm._s(_vm.$filters.capitalize(_vm.$l10n.__("contact")))
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.billingContact.contactName) +
                        " " +
                        _vm._s(_vm.billingContact.contactFirstName) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(_vm._s(_vm.billingContact.contactEmail))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(_vm._s(_vm.billingContact.contactPhone))
                  ]),
                  _vm._v(" "),
                  _vm.billingContact.locale
                    ? _c("p", { staticClass: "m-0" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$filters.capitalize(
                                _vm.$l10n.__(
                                  "Langue de facturation : %(billing_locale)s",
                                  {
                                    billing_locale: _vm.billingLocale.name || ""
                                  }
                                )
                              )
                            ) +
                            "\n                    "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "m-0 flex-column" },
                    _vm._l(
                      _vm.billingSettings.additionalEmailRecipients,
                      function(email, index) {
                        return _c("span", { key: index }, [
                          _vm._v(_vm._s(email))
                        ])
                      }
                    ),
                    0
                  )
                ]),
                _vm._v(" "),
                !_vm.isBillingContactValid
                  ? _c("div", [
                      _c("p", { staticClass: "italic red" }, [
                        _vm._v(_vm._s(_vm.$l10n.__("Informations manquantes")))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "link absolute bottom-2 left-3",
                    on: { click: _vm.editBillingContact }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$filters.capitalize(_vm.$l10n.__("modifier")))
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "well flex-column flex-item-50 pb-5 relative" },
              [
                _c("h4", { staticClass: "mt-0" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$filters.capitalize(
                          _vm.$l10n.__("adresse de facturation")
                        )
                      ) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  !_vm.billingSettings.saasThirdPartyPayerName
                    ? _c("p", { staticClass: "m-0" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.customer.name) +
                            "\n                    "
                        )
                      ])
                    : _c("p", { staticClass: "m-0" }, [
                        _vm._v(
                          _vm._s(_vm.billingSettings.saasThirdPartyPayerName)
                        )
                      ]),
                  _vm._v(" "),
                  !_vm.billingAddress.line1
                    ? _c("p", { staticClass: "italic red" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$l10n.__("Informations manquantes")) +
                            "\n                    "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(_vm._s(_vm.billingAddress.line1))
                  ]),
                  _vm._v(" "),
                  _vm.billingAddress.line2
                    ? _c("p", { staticClass: "m-0" }, [
                        _vm._v(_vm._s(_vm.billingAddress.line2))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "m-0" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.billingAddress.postalCode) +
                        " " +
                        _vm._s(_vm.billingAddress.city) +
                        " -\n                        " +
                        _vm._s(_vm.country.name) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.hasCountryIntraVat(_vm.billingAddress.country)
                    ? _c("p", { staticClass: "m-0" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$filters.capitalize(
                                _vm.$l10n.__(
                                  "n°- de TVA : %(vat_identifier)s",
                                  {
                                    vat_identifier:
                                      _vm.billingSettings
                                        .vatIdentificationNumber || ""
                                  }
                                )
                              )
                            ) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "link absolute bottom-2 left-3",
                    on: { click: _vm.editBillingAddress }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$filters.capitalize(_vm.$l10n.__("modifier")))
                    )
                  ]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "mt-3" }, [
            _vm._v(
              _vm._s(_vm.$filters.capitalize(_vm.$l10n.__("Choix du paiement")))
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              !_vm.isCartContext("upsale")
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "pricingPlan",
                        error: _vm.errors.get("pricingPlan")
                      }
                    },
                    [
                      _c("radio-input", {
                        staticClass: "el-radio-full-width",
                        attrs: {
                          mode: _vm.canPricingPlanBeModified ? "edit" : "read",
                          "radio-style": "button",
                          choices: _vm.pricingPlansChoices
                        },
                        on: {
                          change: function($event) {
                            ;[
                              _vm.switchCartItemPricing($event),
                              _vm.switchPricingPlan($event)
                            ]
                          }
                        },
                        model: {
                          value: _vm.pricingPlanTmp,
                          callback: function($$v) {
                            _vm.pricingPlanTmp = $$v
                          },
                          expression: "pricingPlanTmp"
                        }
                      })
                    ],
                    1
                  )
                : _c("div", [
                    _c("div", { staticClass: "well py-4 acenter semibold" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$filters.capitalize(
                              _vm.pricingPlansChoices.find(function(c) {
                                return c.value == _vm.currentPricingPlan
                              }).label
                            )
                          ) +
                          "\n                "
                      )
                    ])
                  ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.isCartLoaded
            ? _c("el-alert", {
                staticClass: "mt-4",
                attrs: {
                  title: _vm.$t.__(
                    "sellsyaccountmanager.subscriptionform.StepSubscription.your_cart_was_made_by_our_sale"
                  ),
                  closable: false,
                  type: "error"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("h2", { staticClass: "mt-3" }, [
            _vm._v(_vm._s(_vm.$filters.capitalize(_vm.$l10n.__("licence"))))
          ]),
          _vm._v(" "),
          !_vm.isCartContext("new") && !_vm.isCartContext("legacy_renew")
            ? _c("p", [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Vous pouvez faire évoluer votre abonnement en augmentant votre nombre d'utilisateurs et sélectionner un nouvel outil pour améliorer votre productivité !"
                      )
                    ) +
                    "\n        "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.pricingProducts.length
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "well py-4 px-0" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "px-5 pb-2",
                        attrs: {
                          prop: "nbLicences",
                          error: _vm.errors.get("nbLicences")
                        }
                      },
                      [
                        _c("h2", { staticClass: "my-0 flex-level" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$filters.capitalize(
                                  _vm.$l10n.__("nombre d'utilisateurs")
                                )
                              ) +
                              " :\n                        "
                          ),
                          _vm.cartBasicProduct.customPricing
                            ? _c("span", { staticClass: "flex-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.getPricingByPlan(
                                        _vm.basicCustomPricing[0].unit_amount
                                      )
                                    )
                                  ) +
                                    "\n                            " +
                                    _vm._s(
                                      _vm.$l10n.__("par utilisateur / mois")
                                    )
                                )
                              ])
                            : _c("span", { staticClass: "flex-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.getPricingByPlan(
                                        _vm.getProductMonthlyAmount(
                                          _vm.pricingBasicProduct,
                                          _vm.currentPricingPlan
                                        )
                                      )
                                    )
                                  ) +
                                    "\n                            " +
                                    _vm._s(
                                      _vm.$l10n.__("par utilisateur / mois")
                                    )
                                )
                              ])
                        ]),
                        _vm._v(" "),
                        _vm.basicCustomPricing.length &&
                        _vm.getPricingByPlan(
                          _vm.basicCustomPricing[0].unit_amount
                        ) !==
                          _vm.getPricingByPlan(
                            _vm.getProductMonthlyAmount(
                              _vm.pricingBasicProduct,
                              _vm.currentPricingPlan,
                              false
                            )
                          )
                          ? _c("span", { staticClass: "flex-level" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "flex-right gray-60 fs-3 regular"
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$filters.capitalize(
                                          _vm.$l10n.__(
                                            "au lieu de %(amount_f)s par utilisateur par mois",
                                            {
                                              amount_f: _vm.formatAmount(
                                                _vm.getPricingByPlan(
                                                  _vm.getProductMonthlyAmount(
                                                    _vm.pricingBasicProduct,
                                                    _vm.currentPricingPlan,
                                                    false
                                                  )
                                                )
                                              )
                                            }
                                          )
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex-row ai-center mt-4" },
                          [
                            _vm.tmpNbMinLicenses !== 0
                              ? _c("el-slider", {
                                  staticClass: "w-100 slider-free",
                                  attrs: {
                                    marks: _vm.minimalSliderMark,
                                    value: 0,
                                    disabled: ""
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.basicCustomPricing.length
                              ? _c("slider-input", {
                                  class: {
                                    "ml-1 wp-10 slider-priced": true,
                                    "is-max-range":
                                      _vm.tmpNbMinLicenses ===
                                      Math.max(
                                        _vm.maxNbLicences,
                                        _vm.tmpNbLicenses
                                      )
                                  },
                                  attrs: {
                                    mode: _vm.canProductBeToggled(
                                      _vm.pricingBasicProduct,
                                      true
                                    )
                                      ? "edit"
                                      : "read",
                                    min: _vm.tmpNbMinLicenses,
                                    max: Math.max(
                                      _vm.maxNbLicences,
                                      _vm.tmpNbLicenses
                                    ),
                                    marks: {
                                      tmpNbMinLicenses: _vm.tmpNbMinLicenses.toString(),
                                      500: "500"
                                    },
                                    "show-input": ""
                                  },
                                  on: { change: _vm.updatePricingStep },
                                  model: {
                                    value: _vm.nbLicences,
                                    callback: function($$v) {
                                      _vm.nbLicences = $$v
                                    },
                                    expression: "nbLicences"
                                  }
                                })
                              : _c("slider-input", {
                                  class: {
                                    "ml-1 wp-10 slider-priced": true,
                                    "is-max-range":
                                      _vm.tmpNbMinLicenses ===
                                      Math.max(
                                        _vm.maxNbLicences,
                                        _vm.tmpNbLicenses
                                      )
                                  },
                                  attrs: {
                                    mode: _vm.canProductBeToggled(
                                      _vm.pricingBasicProduct,
                                      true
                                    )
                                      ? "edit"
                                      : "read",
                                    value: _vm.tmpNbLicenses,
                                    min: _vm.tmpNbMinLicenses,
                                    max: Math.max(
                                      _vm.maxNbLicences,
                                      _vm.tmpNbLicenses
                                    ),
                                    marks: {
                                      tmpNbMinLicenses: _vm.tmpNbMinLicenses.toString(),
                                      500: "500"
                                    },
                                    "show-input": ""
                                  },
                                  on: { change: _vm.updateNbLicenses }
                                })
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.cartBasicProduct.length > 1
                      ? _c(
                          "div",
                          { staticClass: "bt-1 px-5 py-2" },
                          [
                            _c("h2", { staticClass: "mb-0" }, [
                              _vm._v(_vm._s(_vm.$l10n.__("Inclus")))
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.basicCustomPricing, function(
                              pricing,
                              index
                            ) {
                              return [
                                pricing.unit_amount === 0
                                  ? _c(
                                      "p",
                                      {
                                        key: index,
                                        staticClass: "flex-level jc-space"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "grey semibold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$l10n.n__(
                                                  "Utilisateur offert",
                                                  "Utilisateurs offerts",
                                                  _vm.cartNbOfferedLicenses,
                                                  {
                                                    users:
                                                      _vm.cartNbOfferedLicenses
                                                  }
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "semibold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$l10n.n__(
                                                  "%(users)s utilisateur offert",
                                                  "%(users)s utilisateurs offerts",
                                                  _vm.cartNbOfferedLicenses,
                                                  {
                                                    users:
                                                      _vm.cartNbOfferedLicenses
                                                  }
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : index !== 0
                                  ? _c(
                                      "p",
                                      {
                                        key: index,
                                        staticClass: "flex-level jc-space"
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "grey semibold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$l10n.n__(
                                                  "Utilisateur à tarif préférentiel",
                                                  "Utilisateurs à tarif préférentiel",
                                                  pricing.nbLicences
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "semibold" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$l10n.n__(
                                                  "%(users)s utilisateur à %(amount)s / mois / utilisateur",
                                                  "%(users)s utilisateurs à %(amount)s / mois / utilisateur",
                                                  pricing.nbLicences,
                                                  {
                                                    amount: _vm.formatAmount(
                                                      _vm.getPricingByPlan(
                                                        pricing.unit_amount
                                                      )
                                                    ),
                                                    users: pricing.nbLicences
                                                  }
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "bt-1 px-5 py-2 flex-level" }, [
                      _c("h2", { staticClass: "my-0 fs-4" }, [
                        _vm._v(_vm._s(_vm.$l10n.__("Total")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex-column flex-item-right aright" },
                        [
                          _c("p", { staticClass: "semibold fs-4" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$l10n.n__(
                                    "%s utilisateur",
                                    "%s utilisateurs",
                                    _vm.totalTmpNbLicences,
                                    _vm.totalTmpNbLicences
                                  )
                                ) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$l10n.__(
                                  "Soit %s / mois (remises comprises)",
                                  _vm.formatAmount(_vm.totalOnlyUsersLicences)
                                )
                              )
                            )
                          ])
                        ]
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("h2", { staticClass: "mt-3" }, [
                  _vm._v(
                    _vm._s(_vm.$filters.capitalize(_vm.$l10n.__("outils")))
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "well mt-4 p-5" }, [
                  _c(
                    "ul",
                    { staticClass: "m-0" },
                    [
                      _c("li", { staticClass: "pb-5 flex-level" }, [
                        _c("h3", { staticClass: "flex m-0 mr-3" }, [
                          _vm._v(_vm._s(_vm.pricingBasicProduct.printableName))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "flex-3 gray-60" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.pricingBasicProduct
                                  .printableShortDescription
                              ) +
                              "\n                            "
                          ),
                          _vm.pricingBasicProduct.frontUrlDescription &&
                          _vm.pricingBasicProduct.frontUrlDescription != ""
                            ? _c(
                                "a",
                                {
                                  staticClass: "link",
                                  attrs: {
                                    href:
                                      _vm.pricingBasicProduct
                                        .frontUrlDescription,
                                    target: "_blank"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$l10n.__("En savoir plus")))]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("h2", { staticClass: "flex-3 aright m-0" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$filters.capitalize(_vm.$l10n.__("inclus"))
                              ) +
                              "\n                        "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.quotasByCountryCodeAndPlan, function(quota) {
                        return _c(
                          "li",
                          { key: quota.code, staticClass: "pb-5 flex-level" },
                          [
                            _c("span", { staticClass: "flex m-0 mr-3" }, [
                              _vm._v(" ")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex-3 gray-60" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.quotaPrintableDescription(
                                      quota,
                                      _vm.currentPricingPlan
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("h2", { staticClass: "flex-3 aright m-0" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$filters.capitalize(
                                      _vm.$l10n.__("inclus")
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(
                        _vm.pricingOptionalProductsSubscribableByCustomer,
                        function(product) {
                          return _c(
                            "li",
                            {
                              key: product.code,
                              staticClass: "bt-1 py-5 flex-level"
                            },
                            [
                              _c("h3", { staticClass: "flex m-0 mr-3" }, [
                                _vm._v(_vm._s(product.printableName))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "flex-3 gray-60" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(product.printableShortDescription) +
                                    "\n                            "
                                ),
                                product.frontUrlDescription &&
                                product.frontUrlDescription != ""
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "link",
                                        attrs: {
                                          href: product.frontUrlDescription,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$l10n.__("En savoir plus"))
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "flex-2 aright m-0" }, [
                                _c("h2", { staticClass: "dinlineb m-0" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.formatAmount(
                                          _vm.getPricingByPlan(
                                            _vm.getProductMonthlyAmount(
                                              product,
                                              _vm.currentPricingPlan
                                            )
                                          )
                                        )
                                      ) +
                                      "\n                            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "grey fs-3 regular" },
                                  [_vm._v("/ " + _vm._s(_vm.$l10n.__("mois")))]
                                ),
                                _vm._v(" "),
                                _vm.getProductMonthlyAmount(
                                  product,
                                  _vm.currentPricingPlan
                                ) !==
                                _vm.getProductMonthlyAmount(
                                  product,
                                  _vm.currentPricingPlan,
                                  false
                                )
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "block gray-60 fs-3 regular"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$filters.capitalize(
                                                _vm.l10n.__(
                                                  "au lieu de %(amount_f)s",
                                                  {
                                                    amount_f: _vm.formatAmount(
                                                      _vm.getPricingByPlan(
                                                        _vm.getProductMonthlyAmount(
                                                          product,
                                                          _vm.currentPricingPlan,
                                                          false
                                                        )
                                                      )
                                                    )
                                                  }
                                                )
                                              )
                                            ) +
                                            "\n                                / " +
                                            _vm._s(_vm.$l10n.__("mois")) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "flex aright" },
                                [
                                  _c("el-switch", {
                                    attrs: {
                                      value: !!_vm.getCartItem(product.id),
                                      disabled: !_vm.canProductBeToggled(
                                        product,
                                        false
                                      )
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.toggleItem(product)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        }
                      )
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                !_vm.isCartContext("new") &&
                !_vm.isCartContext("legacy_renew") &&
                _vm.isCurrentPricingMonthly
                  ? _c(
                      "div",
                      { staticClass: "mt-4 my-2 flex-level semibold" },
                      [
                        _c(
                          "span",
                          { staticClass: "m-0 flex-right flex-3 aright" },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$filters.capitalize(
                                    _vm.$l10n.__(
                                      "Total supplémentaire sur votre abonnement"
                                    )
                                  )
                                ) +
                                "\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "flex-right flex-1 aright" },
                          [
                            _vm.newItemsOnSubscriptionTotalForCurrentPricingPlan
                              .totalDiscounted > 0
                              ? _c("span", [_vm._v("+ ")])
                              : _vm._e(),
                            _vm._v(
                              _vm._s(
                                _vm.formatAmount(
                                  _vm
                                    .newItemsOnSubscriptionTotalForCurrentPricingPlan
                                    .totalDiscounted
                                )
                              ) +
                                "\n                    " +
                                _vm._s(
                                  _vm.$l10n.p__("without_tax_acronym", "HT")
                                ) +
                                " /\n                    " +
                                _vm._s(
                                  _vm.$filters.capitalize(_vm.$l10n.__("mois"))
                                ) +
                                "\n                "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isCurrentPricingMonthly
                  ? _c("div", { staticClass: "mt-4" }, [
                      !_vm.isCartContext("upsale")
                        ? _c(
                            "div",
                            [
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "wp-6 flex-level flex-item-right mb-1"
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$filters.capitalize(
                                          _vm.$l10n.__("total mensuel HT")
                                        )
                                      ) +
                                      "\n                        "
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "fs-4 flex-right" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.currentPricingTotal
                                              .totalDiscounted
                                          )
                                        ) +
                                          " /\n                            " +
                                          _vm._s(_vm.$l10n.__("mois"))
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.cartHasDiscount
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "my-1 wp-6 flex-level flex-item-right"
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$filters.capitalize(
                                              _vm.$l10n.__(
                                                "Dont remise mensuelle"
                                              )
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "fs-3 flex-right" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm.currentPricingTotal.discount
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showTaxTotal && _vm.currentCountryTaxRate > 0
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "my-1 wp-6 flex-level flex-item-right"
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.$l10n.__("TVA")) +
                                          " (" +
                                          _vm._s(
                                            _vm.currentCountryTaxRate * 100
                                          ) +
                                          "%)\n                        "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "fs-3 flex-right" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm.currentPricingTotal.tax,
                                                true
                                              )
                                            ) + "\n                        "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showTaxTotal && _vm.currentCountryTaxRate > 0
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "my-1 wp-6 flex-level flex-item-right"
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$filters.capitalize(
                                              _vm.$l10n.__("total mensuel TTC")
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "fs-3 flex-right" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm.currentPricingTotal
                                                  .totalTaxIncluded,
                                                true
                                              )
                                            ) + "\n                        "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "my-1 wp-6 flex-level flex-item-right"
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "fs-3 flex-right" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$l10n.__("Engagement sur 12 mois")
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.deadlines.length > 0
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "my-1 wp-6 flex-level flex-item-right semibold"
                                    },
                                    [
                                      _c("span", { staticClass: "fs-3" }, [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$filters.capitalize(
                                                _vm.$l10n.__("échéancier")
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.cartEarlyRenewal
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "my-1 wp-6 flex-level flex-item-right"
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$filters.capitalize(
                                              _vm.$l10n.__(
                                                "Restant à consommer"
                                              )
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "fs-3 flex-right" },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.formatAmount(
                                                  -1 *
                                                    _vm.centsToCurrency(
                                                      _vm.cartEarlyRenewalDiscount
                                                    ),
                                                  true
                                                )
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.deadlines, function(deadline) {
                                return _c(
                                  "p",
                                  {
                                    key: deadline.key,
                                    staticClass:
                                      "my-1 wp-6 flex-level flex-item-right gray-60"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$filters.dateFormatter(
                                            deadline.date.unix(),
                                            "NORMAL_DATE",
                                            false
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "fs-3 flex-right" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              deadline.amount,
                                              true
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _vm.deadlineUnchanged > 0 &&
                              _vm.deadlineUnchanged < 12
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "my-1 wp-6 flex-level flex-item-right gray-60"
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$l10n.__(
                                              "%(deadlineUnchanged)s échéances suivantes",
                                              {
                                                deadlineUnchanged:
                                                  _vm.deadlineUnchanged
                                              }
                                            )
                                          ) +
                                          "\n                        "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "fs-3 flex-right" },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.formatAmount(
                                                  _vm.currentPricingTotal
                                                    .totalTaxIncluded,
                                                  true
                                                )
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        : _c("div", [
                            _c(
                              "div",
                              { staticClass: "my-2 flex-level fs-4 bold" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "m-0 flex-right flex-3 aright"
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$filters.capitalize(
                                            _vm.$l10n.__(
                                              "total mensuel HT de votre abonnement"
                                            )
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "flex-right flex-1 aright" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.currentPricingTotal
                                              .totalDiscounted
                                          )
                                        ) +
                                        " /\n                            " +
                                        _vm._s(
                                          _vm.$filters.capitalize(
                                            _vm.$l10n.__("mois")
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.cartHasDiscount
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "my-2 flex-level semibold gray-60"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-0 flex-right flex-3 aright semibold gray-60"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$l10n.__(
                                                "Dont remise mensuelle"
                                              )
                                            ) +
                                            " (" +
                                            _vm._s(
                                              _vm.currentCountryTaxRate * 100
                                            ) +
                                            "%)\n                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "flex-right flex-1 aright"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm.currentPricingTotal.discount
                                              )
                                            ) +
                                            " /\n                            " +
                                            _vm._s(
                                              _vm.$filters.capitalize(
                                                _vm.$l10n.__("mois")
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showTaxTotal && _vm.currentCountryTaxRate > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "my-2 flex-level semibold gray-60"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-0 flex-right flex-3 aright semibold gray-60"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$l10n.__("TVA")) +
                                            " (" +
                                            _vm._s(
                                              _vm.currentCountryTaxRate * 100
                                            ) +
                                            "%)\n                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "flex-right flex-1 aright"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm.currentPricingTotal.tax,
                                                true
                                              )
                                            ) +
                                            " /\n                            " +
                                            _vm._s(
                                              _vm.$filters.capitalize(
                                                _vm.$l10n.__("mois")
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showTaxTotal && _vm.currentCountryTaxRate > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "my-2 flex-level semibold gray-60"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-0 flex-right flex-3 aright semibold gray-60"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$filters.capitalize(
                                                _vm.$l10n.__(
                                                  "total mensuel TTC"
                                                )
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "flex-right flex-1 aright"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm.currentPricingTotal
                                                  .totalTaxIncluded,
                                                true
                                              )
                                            ) +
                                            " /\n                            " +
                                            _vm._s(
                                              _vm.$filters.capitalize(
                                                _vm.$l10n.__("mois")
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                    ])
                  : _c("div", { staticClass: "mt-4" }, [
                      !_vm.isCartContext("upsale")
                        ? _c("div", [
                            !_vm.cartHasDiscount
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-1 wp-6 flex-level flex-item-right gray-60"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$filters.capitalize(
                                            _vm.$l10n.__(
                                              "Économie réalisée en payant mon abonnement en une fois"
                                            )
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "fs-3 flex-right" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              _vm.diffMonthlyYearly
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isPaymentFacilityEnabled
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-1 wp-6 flex-level flex-item-right gray-60"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$filters.capitalize(
                                            _vm.$l10n.__(
                                              "Paiement en %s fois activé",
                                              _vm.cartPaymentFacility
                                            )
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isCustomPaymentFacilityEnabled
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-1 wp-6 flex-level flex-item-right gray-60"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$filters.capitalize(
                                            _vm.$l10n.__(
                                              "Paiement en %s fois activé",
                                              _vm.cartNbCustomFacilities
                                            )
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.cartEarlyRenewal
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-1 wp-6 flex-level flex-item-right"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$filters.capitalize(
                                            _vm.$l10n.__("Montant HT")
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "fs-3 flex-right" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              _vm.currentPricingTotal
                                                .totalWithCutomPricingYearly
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.cartEarlyRenewal
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-1 wp-6 flex-level flex-item-right"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$filters.capitalize(
                                            _vm.$l10n.__("Restant à consommer")
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "fs-3 flex-right" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              -1 *
                                                _vm.centsToCurrency(
                                                  _vm.cartEarlyRenewalDiscount
                                                ),
                                              true
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "h2",
                              {
                                staticClass:
                                  "wp-6 flex-level flex-item-right mb-1"
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$filters.capitalize(
                                        _vm.$l10n.__("total HT")
                                      )
                                    ) +
                                    "\n                        "
                                ),
                                _c("span", { staticClass: "fs-4 flex-right" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatAmount(
                                        _vm.currentPricingTotal.totalDiscounted,
                                        true
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.cartHasDiscount
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-1 wp-6 flex-level flex-item-right"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$filters.capitalize(
                                            _vm.$l10n.__("Dont remise annuelle")
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "fs-3 flex-right" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              _vm.currentPricingTotal.discount,
                                              true
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showTaxTotal && _vm.currentCountryTaxRate > 0
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-1 wp-6 flex-level flex-item-right"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.$l10n.__("TVA")) +
                                        " (" +
                                        _vm._s(
                                          _vm.currentCountryTaxRate * 100
                                        ) +
                                        "%)\n                        "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "fs-3 flex-right" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              _vm.currentPricingTotal.tax,
                                              true
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showTaxTotal && _vm.currentCountryTaxRate > 0
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-1 wp-6 flex-level flex-item-right"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$filters.capitalize(
                                            _vm.$l10n.__("total TTC")
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "fs-3 flex-right" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatAmount(
                                              _vm.currentPricingTotal
                                                .totalTaxIncluded,
                                              true
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isPaymentFacilityEnabled
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-1 wp-6 flex-level flex-item-right"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$filters.capitalize(
                                            _vm.$l10n.__(
                                              "Paiement en %s fois",
                                              _vm.cartPaymentFacility
                                            )
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                    _vm.cartNextAmountFacility <
                                    _vm.cartFirstAmountFacility
                                      ? _c(
                                          "span",
                                          { staticClass: "fs-3 flex-right" },
                                          [
                                            _vm._v(
                                              "\n                            1 x " +
                                                _vm._s(
                                                  _vm.formatAmount(
                                                    _vm.cartFirstAmountFacility,
                                                    true
                                                  )
                                                )
                                            ),
                                            _c("br")
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "fs-3 flex-right" },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.cartPaymentFacility
                                                ) +
                                                " x\n                            " +
                                                _vm._s(
                                                  _vm.formatAmount(
                                                    _vm.cartFirstAmountFacility,
                                                    true
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]
                                        )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isPaymentFacilityEnabled &&
                            _vm.cartNextAmountFacility <
                              _vm.cartFirstAmountFacility
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-1 wp-6 flex-level flex-item-right"
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "fs-3 flex-right" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.cartPaymentFacility - 1
                                            ) +
                                            " x\n                            " +
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm.cartNextAmountFacility,
                                                true
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isCustomPaymentFacilityEnabled
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-1 wp-6 flex-level flex-item-right"
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.$filters.capitalize(
                                            _vm.$l10n.__(
                                              "Paiement en %s fois",
                                              _vm.cartNbCustomFacilities
                                            )
                                          )
                                        ) +
                                        "\n                        "
                                    ),
                                    _vm.cartFirstAmountCustomFacility <
                                    _vm.cartLastAmountCustomFacility
                                      ? _c(
                                          "span",
                                          { staticClass: "fs-3 flex-right" },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.cartNbFirstCustomFacilities
                                                ) +
                                                " x\n                            " +
                                                _vm._s(
                                                  _vm.formatAmount(
                                                    _vm.cartFirstAmountCustomFacility,
                                                    true
                                                  )
                                                )
                                            ),
                                            _c("br")
                                          ]
                                        )
                                      : _c(
                                          "span",
                                          { staticClass: "fs-3 flex-right" },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.cartNbCustomFacilities
                                                ) +
                                                " x\n                            " +
                                                _vm._s(
                                                  _vm.formatAmount(
                                                    _vm.cartFirstAmountFacility,
                                                    true
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]
                                        )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isCustomPaymentFacilityEnabled &&
                            _vm.cartFirstAmountCustomFacility <
                              _vm.cartLastAmountCustomFacility
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-1 wp-6 flex-level flex-item-right"
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "fs-3 flex-right" },
                                      [
                                        _vm._v(
                                          "\n                            1 x " +
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm.cartLastAmountCustomFacility,
                                                true
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _c("div", [
                            _c(
                              "div",
                              { staticClass: "my-2 flex-level fs-4 bold" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "m-0 flex-right flex-3 aright"
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$filters.capitalize(
                                            _vm.$l10n.__(
                                              "total HT supplémentaire estimé à payer*"
                                            )
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "flex-right flex-1 aright" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm
                                              .newItemsOnSubscriptionTotalForCurrentPricingPlan
                                              .totalDiscounted
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.showTaxTotal && _vm.currentCountryTaxRate > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "my-2 flex-level semibold gray-60"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-0 flex-right flex-3 aright semibold gray-60"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$l10n.__("TVA estimée")
                                            ) +
                                            " (" +
                                            _vm._s(
                                              _vm.currentCountryTaxRate * 100
                                            ) +
                                            "%)\n                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "flex-right flex-1 aright"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm
                                                  .newItemsOnSubscriptionTotalForCurrentPricingPlan
                                                  .tax
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showTaxTotal && _vm.currentCountryTaxRate > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "my-2 flex-level semibold gray-60"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "m-0 flex-right flex-3 aright"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$filters.capitalize(
                                                _vm.$l10n.__(
                                                  "total TTC supplémentaire estimé à payer*"
                                                )
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "flex-right flex-1 aright"
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.formatAmount(
                                                _vm
                                                  .newItemsOnSubscriptionTotalForCurrentPricingPlan
                                                  .totalTaxIncluded
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                    ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isCartContext("new") && _vm.cartPeriodStartDate
            ? _c("div", { staticClass: "well mt-4 p-3 flex-level" }, [
                _c("span", { staticClass: "flex-1" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$l10n.__("Date d'activation de votre abonnement")
                    ) + ":"
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "flex-right semibold" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$filters.dateFormatter(
                          _vm.cartPeriodStartDateObj.unix(),
                          "NORMAL_DATE",
                          false
                        )
                      ) +
                      "\n            "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          (_vm.isCartContext("legacy_renew") || _vm.isCartContext("renew")) &&
          _vm.cartPeriodStartDate
            ? _c("div", { staticClass: "well mt-4 p-3 flex-level" }, [
                _c("span", { staticClass: "flex-1" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Date de renouvellement de votre abonnement"
                        )
                      ) +
                      ":"
                  )
                ]),
                _vm._v(" "),
                !_vm.cartEarlyRenewal
                  ? _c("span", { staticClass: "flex-right semibold" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$filters.dateFormatter(
                              _vm.cartPeriodStartDateObj.unix(),
                              "NORMAL_DATE",
                              false
                            )
                          ) +
                          "\n            "
                      )
                    ])
                  : _c("span", { staticClass: "flex-right semibold" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$filters.dateFormatter(
                              _vm.now.unix(),
                              "NORMAL_DATE",
                              false
                            )
                          ) +
                          "\n            "
                      )
                    ])
              ])
            : !_vm.isCartContext("new") && _vm.customerServiceEndDate
            ? _c("div", { staticClass: "well mt-4 p-4 flex-level" }, [
                _c("span", { staticClass: "flex-1" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__(
                          "La date de votre fin d'abonnement est le :"
                        )
                      ) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "flex-right semibold" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$filters.dateFormatter(
                          _vm.customerServiceEndDateObj.unix(),
                          "NORMAL_DATE",
                          false
                        )
                      ) +
                      "\n            "
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isCartContext("renew")
            ? _c("div", { staticClass: "my-5 px-5 acenter" }, [
                _vm.cartPaymentMethod == "stripe_card"
                  ? _c("p", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$filters.capitalize(
                              _vm.$l10n.__(
                                "la facture sera éditée et prélevée le %(date)s",
                                {
                                  date: _vm.$filters.dateFormatter(
                                    _vm.cartInvoiceEditionDate.unix(),
                                    "SLASHED_DATE",
                                    false
                                  )
                                }
                              )
                            )
                          ) +
                          "\n            "
                      )
                    ])
                  : _c("p", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$filters.capitalize(
                              _vm.$l10n.__(
                                "la facture sera éditée le %(date)s",
                                {
                                  date: _vm.$filters.dateFormatter(
                                    _vm.cartInvoiceEditionDate.unix(),
                                    "SLASHED_DATE",
                                    false
                                  )
                                }
                              )
                            )
                          ) +
                          "\n            "
                      )
                    ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isCartContext("upsale")
            ? _c("div", { staticClass: "my-5 px-5" }, [
                _vm.isCurrentPricingMonthly
                  ? _c("p", [
                      _c("span", { staticClass: "semibold" }, [
                        _vm._v(_vm._s(_vm.$l10n.__("Attention")) + " :")
                      ]),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$l10n.__(
                              "La prochaine facture est calculée prorata temporis, les échéances suivantes au taux plein"
                            )
                          ) +
                          ".\n            "
                      )
                    ])
                  : _c("p", { staticClass: "my-5" }, [
                      _vm._v(
                        "\n                *\n                " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Ce montant est une estimation pour un prorata à cet instant. Le montant exact de la facture sera calculé au prorata du temps restant sur votre abonnement au moment du paiement."
                            )
                          ) +
                          "\n            "
                      )
                    ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-primary btn-block mt-5",
              attrs: { role: "button", disabled: !_vm.canCartBeSaved },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.canCartBeSaved ? _vm.submitForm("subscriptionForm") : ""
                }
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$filters.capitalize(_vm.$l10n.__("valider mon panier"))
                  ) +
                  "\n        "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "well acenter shadow p-0", attrs: { id: "sticky" } },
        [
          !_vm.isCartContext("upsale")
            ? _c(
                "div",
                [
                  _c("p", { staticClass: "title mt-3 gray-60 m-0" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$filters.capitalize(
                            _vm.$l10n.__("votre abonnement")
                          )
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "my-3" },
                    [
                      _c("h2", { staticClass: "m-0" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$l10n.n__(
                                "%(users)s utilisateur",
                                "%(users)s utilisateurs",
                                _vm.totalTmpNbLicences,
                                { users: _vm.totalTmpNbLicences }
                              )
                            ) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.basicCustomPricing, function(pricing, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "gray-60" },
                          [
                            pricing.unit_amount === 0
                              ? _c("span", [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$l10n.n__(
                                          "%(users)s utilisateur offert",
                                          "%(users)s utilisateurs offerts",
                                          _vm.cartNbOfferedLicenses,
                                          { users: _vm.cartNbOfferedLicenses }
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$l10n.n__(
                                        "%(users)s utilisateur : %(amount)s /mois",
                                        "%(users)s utilisateurs : %(amount)s /mois",
                                        pricing.nbLicences,
                                        {
                                          amount: _vm.formatAmount(
                                            _vm.getPricingByPlan(
                                              pricing.unit_amount
                                            )
                                          ),
                                          users: pricing.nbLicences
                                        }
                                      )
                                    )
                                  )
                                ])
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.sortProducts(_vm.cartItemsIterable), function(
                    item,
                    index
                  ) {
                    return _c(
                      "p",
                      { key: index, staticClass: "m-0 semibold" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$filters.capitalize(index > 0 ? "+ " : null) +
                                "\n                " +
                                _vm._s(item.product.printableName)
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "my-3" }, [
                    _c("h2", { staticClass: "m-0" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatAmount(
                            _vm.cartTotal.monthly.totalDiscounted
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "grey regular fs-3" }, [
                      _vm._v(
                        _vm._s(_vm.$l10n.p__("without_tax_acronym", "HT")) +
                          " / " +
                          _vm._s(_vm.$l10n.__("mois"))
                      )
                    ])
                  ])
                ],
                2
              )
            : _vm._m(0),
          _vm._v(" "),
          _vm.isCartContext("upsale")
            ? _c(
                "div",
                [
                  _c("p", { staticClass: "title mt-3 m-0" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$filters.capitalize(
                            _vm.$l10n.__("évolution de votre abonnement")
                          )
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "my-3" },
                    [
                      _c("h2", { staticClass: "m-0" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$l10n.n__(
                                "%(users)s utilisateur",
                                "%(users)s utilisateurs",
                                _vm.totalTmpNbLicences,
                                { users: _vm.totalTmpNbLicences }
                              )
                            ) +
                            "\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.basicCustomPricing, function(pricing, index) {
                        return _c("div", { key: index }, [
                          pricing.unit_amount === 0
                            ? _c("span", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$l10n.n__(
                                        "%(users)s utilisateur offert",
                                        "%(users)s utilisateurs offerts",
                                        pricing.nbLicences,
                                        { users: pricing.nbLicences }
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$l10n.n__(
                                      "%(users)s utilisateur : %(amount)s /mois",
                                      "%(users)s utilisateurs : %(amount)s /mois",
                                      pricing.nbLicences,
                                      {
                                        amount: _vm.formatAmount(
                                          _vm.getPricingByPlan(
                                            pricing.unit_amount
                                          )
                                        ),
                                        users: pricing.nbLicences
                                      }
                                    )
                                  )
                                )
                              ])
                        ])
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.sortProducts(_vm.cartItemsIterable), function(
                    item,
                    index
                  ) {
                    return _c(
                      "p",
                      { key: index, staticClass: "m-0 semibold" },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$filters.capitalize(index > 0 ? "+ " : null) +
                                "\n                " +
                                _vm._s(item.product.printableName)
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "my-3" }, [
                    _c("h2", { staticClass: "m-0" }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatAmount(
                            _vm.cartTotal.monthly.totalDiscounted
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "regular fs-3" }, [
                      _vm._v(
                        _vm._s(_vm.$l10n.p__("without_tax_acronym", "HT")) +
                          " / " +
                          _vm._s(_vm.$l10n.__("mois"))
                      )
                    ])
                  ])
                ],
                2
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      [
        _c("p", { staticClass: "title mt-3 gray-60 m-0" }, [
          _vm._v(
            "\n                " +
              _vm._s(
                _vm.$filters.capitalize(_vm.$l10n.__("votre abonnement actuel"))
              ) +
              "\n            "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "my-3" },
          [
            _c("h2", { staticClass: "m-0" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$l10n.n__(
                      "%(users)s utilisateur",
                      "%(users)s utilisateurs",
                      _vm.customerSubscribedLicenses,
                      { users: _vm.customerSubscribedLicenses }
                    )
                  ) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _vm._l(
              _vm
                .defineQuantityAppliedForEachPricingTier(
                  _vm.customerSubscribedBasicProductCustomPricing,
                  _vm.customerSubscribedLicenses
                )
                .reverse(),
              function(pricing, index) {
                return _c("div", { key: index, staticClass: "gray-60" }, [
                  pricing.unit_amount === 0
                    ? _c("span", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$l10n.n__(
                                "%(users)s utilisateur offert",
                                "%(users)s utilisateurs offerts",
                                pricing.nbLicences,
                                { users: pricing.nbLicences }
                              )
                            ) +
                            "\n                    "
                        )
                      ])
                    : _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$l10n.n__(
                              "%(users)s utilisateur : %(amount)s /mois",
                              "%(users)s utilisateurs : %(amount)s /mois",
                              pricing.nbLicences,
                              {
                                amount: _vm.formatAmount(
                                  _vm.getPricingByPlan(pricing.unit_amount)
                                ),
                                users: pricing.nbLicences
                              }
                            )
                          )
                        )
                      ])
                ])
              }
            )
          ],
          2
        ),
        _vm._v(" "),
        _vm._l(_vm.sortProducts(_vm.subscribedProductsIterable), function(
          item,
          index
        ) {
          return _c("p", { key: index, staticClass: "m-0 semibold" }, [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.$filters.capitalize(index > 0 ? "+ " : null) +
                    "\n                " +
                    _vm._s(item.product.printableName)
                ) +
                "\n            "
            )
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "my-3" }, [
          _c("h2", { staticClass: "m-0" }, [
            _vm._v(
              "\n                    " +
                _vm._s(
                  _vm.formatAmount(
                    _vm.customerSubscribedTotal.monthly.totalDiscounted
                  )
                ) +
                "\n                "
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "grey regular fs-3" }, [
            _vm._v(
              _vm._s(_vm.$l10n.p__("without_tax_acronym", "HT")) +
                " / " +
                _vm._s(_vm.$l10n.__("mois"))
            )
          ])
        ])
      ],
      2
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }